import fp from 'lodash/fp';
import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styles from './HelpInfo.module.scss';
import { downloadLog, downloadAppInsightsLog } from '../../api/logDownloadApi';
import DownloadLogsIcon from '../../webcommon/common/Icons/DownloadLogs.svg';

function GetInfo(simmVersion){
   return [
        {
            title: 'Release Version',
            value: fp.get('APP_ENV_CONFIG.REACT_APP_RELEASE_NAME')(window)
        },
        {
            title: 'SIMM Version',
            value: simmVersion
        },
        {
            title: 'Environment',
            value: fp.get('APP_ENV_CONFIG.REACT_APP_ENVIRONMENT')(window)
        }
    ]

}

function getTodayDateString() {
    return new Date().toISOString().slice(0, 10);
}

/** Surface API plain-text error bodies when responseType is blob (axios leaves errors as Blob). */
async function axiosErrorDetail(error) {
    const data = error.response && error.response.data;
    if (data instanceof Blob) {
        try {
            const text = await data.text();
            if (text && text.trim()) return text.trim();
        } catch {
            /* ignore */
        }
    }
    return error.message || '';
}

function isLogDownloadAllowed(env, userRole) {
    if (env !== 'prod') return true;
    return Array.isArray(userRole) && userRole.some(r => r.role === 'ExecuteJobs');
}

const HelpInfo = (props)=> {
    const [downloading, setDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState(null);
    const [downloadingAI, setDownloadingAI] = useState(false);
    const [downloadAIError, setDownloadAIError] = useState(null);

    const env = fp.get('APP_ENV_CONFIG.REACT_APP_ENVIRONMENT')(window);
    const logDownloadAllowed = isLogDownloadAllowed(env, props.userRole);

    const handleDownloadLog = async () => {
        const date = getTodayDateString();
        setDownloading(true);
        setDownloadError(null);
        try {
            const blob = await downloadLog(date);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${date}.log`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            const detail = await axiosErrorDetail(e);
            setDownloadError(detail ? `Failed to download log: ${detail}` : 'Failed to download log');
        } finally {
            setDownloading(false);
        }
    };

    const handleDownloadAppInsightsLog = async () => {
        const date = getTodayDateString();
        setDownloadingAI(true);
        setDownloadAIError(null);
        try {
            const blob = await downloadAppInsightsLog(date);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${date}-appinsights.log`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            const detail = await axiosErrorDetail(e);
            setDownloadAIError(detail ? `Failed to download App Insights log: ${detail}` : 'Failed to download App Insights log');
        } finally {
            setDownloadingAI(false);
        }
    };

    return(
    <div>
        {
            GetInfo(props.simmVersion).map(option => (
            <div key={ option.title } className={ styles.appInfo }>
                <div className={ styles.title }>{option.title}</div>
                <div className={ styles.value }>{option.value}</div>
            </div>
        ))}
        <div className={ styles.appInfo }>
            <div className={ styles.title }>Logs</div>
            <div className={ styles.value }>
                <button
                    onClick={ handleDownloadLog }
                    disabled={ downloading || !logDownloadAllowed }
                    title={ logDownloadAllowed ? "Download today's log file from blob storage" : "Log download is restricted to Support role in production" }
                    className={ styles.downloadLogButton }
                >
                    <img src={ DownloadLogsIcon } alt="Download" className={ styles.downloadLogIcon } />
                    { downloading ? 'Downloading...' : "Download today's log" }
                </button>
                { downloadError && <div className={ styles.downloadLogError }>{ downloadError }</div> }
                <button
                    onClick={ handleDownloadAppInsightsLog }
                    disabled={ downloadingAI || !logDownloadAllowed }
                    title={ logDownloadAllowed ? "Download today's log from Application Insights" : "Log download is restricted to Support role in production" }
                    className={ styles.downloadLogButton }
                >
                    <img src={ DownloadLogsIcon } alt="Download" className={ styles.downloadLogIcon } />
                    { downloadingAI ? 'Downloading...' : "Download App Insights log" }
                </button>
                { downloadAIError && <div className={ styles.downloadLogError }>{ downloadAIError }</div> }
            </div>
        </div>
    </div>
    );
}



const mapStateToProps = state => (
    {
        simmVersion: state.app.simmVersion,
        userRole: state.settings.userRole
    }
)

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpInfo));
